import css from './EmptyPage.module.scss'

export default function EmptyPage({ iconName, title, text, button}) {
    return (
        <div className={css["box"]}>
            <i className={iconName + " " + css["icon"]} />
            <h2 className={css["title"]}>{title}</h2>
            <p className={css["text"]}>{text}</p>
            {button}
            {/* <div className={css["circle"]} /> */}
        </div>
    )
}